import React, { useRef } from 'react'
import { MuiThemeProvider, makeStyles } from '@material-ui/core/styles'

import MaterialTable, { MTableCell } from '@material-table/core'
import { table } from '../../services/theme'
import { NotesToolbar } from './Toolbars/Notes/NotesToolbar'

const useStyles = makeStyles((theme) => ({
	headerButton: {
		fontFamily: 'Nunito',
		fontWeight: '700',
		'& .MuiButton-label': {
			lineHeight: '19px',
			fontSize: '14px'
		}
	},
	addClientButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		}
	},
	toolbarWrapper: {
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: '#F9F9F9'
	},
	petStatusIcon: {
		position: 'absolute',
		left: 0
	},
	toolbarExtras: {
		display: 'flex',
		'& > *': {
			marginRight: '16px'
		}
	},
	toolbar: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		padding: '0px 12px',
		'& > div:nth-child(1)': {
			'& > div:nth-child(4)': {
				flex: 'auto'
			}
		}
	},
	datePickerContainer: {
		display: 'flex',
		alignItems: 'center',
		position: 'relative'
	},
	datePicker: {
		color: '#FFFFFF',
		opacity: 0,
		position: 'absolute',
		top: 0,
		height: 38,
		margin: 0,
		'& *': {
			height: 0,
			padding: 0,
			margin: 0
		}
	},
	calendarButton: {
		'& svg': {
			fill: theme.palette.primary.main
		}
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	calendarDateButton: {
		zIndex: 1,
		border: '1px solid #D0CFD2',
		padding: '7px 16px 8px 24px',
		color: '#4D4C4F',
		fontWeight: '700',
		'& .MuiButton-label': {
			'& .MuiButton-endIcon': {
				marginLeft: 16
			},
			whiteSpace: 'nowrap'
		}
	},
	dateChangeButton: {
		border: '1px solid #D0CFD2',
		height: 38,
		width: 38,
		padding: 5,
		'& svg': {
			height: 16
		}
	},
	addAppointmentButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		}
	},
	tables: {
		display: 'flex',
		width: '100%',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: 10,
		paddingRight: 15,
		paddingLeft: 15
	},
	playgroups: {
		display: 'flex',
		width: '100%',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		padding: 10,
		paddingRight: 15,
		paddingLeft: 15
	},
	colTitle: {
		fontFamily: 'Nunito',
		fontSize: 12,
		fontWeight: '800',
		letterSpacing: 0.75,
		color: '#1A1A35',
		marginBottom: 5
	},
	groupCol: {
		width: '24%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		padding: '5px',
		'& p': {
			margin: 0
		},
		'& .change': {
			fontFamily: 'Nunito',
			fontSize: 14,
			fontWeight: '600',
			color: '#6B4AD6',
			lineHeight: '23px',
			cursor: 'pointer'
		},
		'& .char': {
			fontFamily: 'Nunito',
			fontSize: 14,
			fontWeight: '600',
			color: '#6B4AD6',
			lineHeight: '23px',
			cursor: 'pointer',
			backgroundColor: 'rgba(107, 74, 214, 0.1)',
			padding: 4,
			borderRadius: 6,
			marginRight: 4,
			marginBottom: 4
		}
	},
	timeTable: {
		width: '24%',
		backgroundColor: '#F3F3F3',
		borderRadius: 6,
		display: 'flex',
		flexDirection: 'column',
		padding: 14,
		justifyContent: 'flex-start',
		'& h4': {
			marginTop: 0,
			marginBottom: 5,
			textTransform: 'capitalize',
			fontFamily: 'Nunito',
			fontWeight: '800',
			fontSize: 16
		}
	},
	timeRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		marginBottom: 5,
		padding: 4,
		width: '100%',
		'& span': {
			textTransform: 'capitalize',
			fontFamily: 'Nunito',
			fontWeight: '600',
			fontSize: 14
		}
	},
	timeRowLight: {
		backgroundColor: '#F9F9F9',
		borderRadius: 6
	},
	chipRow: {
		height: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
	},
	spacer: {
		margin: '5px 16px 5px 0px',
		width: '24px',
		position: 'relative',
		'&:before': {
			content: "''",
			position: 'absolute',
			height: '1px',
			width: '100%',
			top: 'calc(50% - 1px)',
			left: 0,
			backgroundColor: '#F3F3F3'
		}
	},
	unassigned: {
		width: '100%',
		backgroundColor: '#6B4AD6',
		borderRadius: 6,
		height: 70,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: 20,
		cursor: 'pointer',
		'& h5': {
			fontFamily: 'Nunito',
			color: '#FFF',
			fontWeight: '800',
			fontSize: 16,
			margin: 0
		},
		'& i': {
			color: 'rgba(255, 255, 255, 0.6)',
			fontSize: 18
		}
	},
	group: {
		width: '100%',
		padding: 15,
		backgroundColor: '#FFF',
		borderRadius: 6,
		marginBottom: 15
		// cursor: "pointer"
	},
	topRow: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		cursor: 'pointer',
		marginBottom: 10
	},
	groupBody: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-evenly',
		alignItems: 'flex-start',
		padding: 15,
		backgroundColor: '#F9F9F9',
		borderRadius: 6
	},
	capacity: {
		fontFamily: 'Nunito',
		fontSize: 24,
		fontWeight: '800',
		color: '#1A1A35'
	},
	playBlock: {
		fontFamily: 'Nunito',
		fontSize: 16,
		fontWeight: '600',
		color: '#1A1A35',
		overflow: 'hidden',
		'& div': {
			// display: "flex",
			// flexDirection: "row",
			// justifyContent: "space-between"
		}
	},
	playName: {
		marginRight: 20
	},
	kennelBlock: {
		fontFamily: 'Nunito',
		fontSize: 16,
		fontWeight: '600',
		color: '#777679',
		width: '50px',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis'
	},
	characteristics: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		justifyContent: 'flex-start'
	},
	change: {},
	staff: {},
	staffRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		'& div': {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'flex-start'
		},
		'& h5': {
			fontFamily: 'Nunito',
			fontSize: 16,
			lineHeight: '22px',
			fontWeight: '600',
			color: '#1A1A35',
			margin: 0,
			marginRight: '10px'
		},
		'& span': {
			fontFamily: 'Nunito',
			fontSize: 16,
			lineHeight: '22px',
			fontWeight: '600',
			color: '#777679',
			marginRight: '10px'
		}
	}
}))

export const NotesTable = (props) => {
	const classes = useStyles()
	const tableRef = useRef(null)
	const toolbarRef = useRef(null)

	let {
		date,
		setDate,
		changeDate,
		aggregates,
		data,
		columns,
		setFilters,
		selectedFilters,
		search,
		setSearch
	} = props

	return (
		<div className={classes.page}>
			<MuiThemeProvider theme={table}>
				<NotesToolbar
					ref={toolbarRef}
					tableRef={tableRef}
					date={date}
					setDate={setDate}
					changeDate={changeDate}
					setFilters={setFilters}
					selectedFilters={selectedFilters}
					search={search}
					setSearch={setSearch}
				/>
				<MaterialTable
					tableRef={tableRef}
					date={props.date}
					options={{
						toolbar: false,
						headerStyle: {
							color: '#1A1A35',
							textTransform: 'uppercase',
							fontWeight: 800,
							fontSize: '12px',
							lineHeight: '16px',
							padding: '11px 24px',
							borderTop: '1px solid #D0CFD2',
							backgroundColor: '#F9F9F9'
						},
						rowStyle: {
							verticalAlign: 'top',
							fontSize: 16
						},
						pageSize: 10,
						pageSizeOptions: [10, 20, 50],
						toolbarButtonAlignment: 'left',
						searchFieldAlignment: 'left'
					}}
					columns={columns}
					data={data}
					components={{
						Cell: (props) => (
							<MTableCell
								style={{
									borderBottom: 'none',
									padding: '16px 36px 16px 24px'
								}}
								{...props}
							/>
						)
					}}
					title="Night Kennels"
				/>
			</MuiThemeProvider>
		</div>
	)
}
